import React from 'react';
import { StyledNumbersWrap } from './StyledNumbersWrap';

const NumbersWrap = ({ children, newHome }) => {
  return (
    <React.Fragment>
      {
        <StyledNumbersWrap newHome={newHome}>
          {children}
        </StyledNumbersWrap>
          
      }
    </React.Fragment>
  );
};

export default NumbersWrap;
